import React from 'react'
import InfoIcon from '../../../../../../../../../Components/Icons/InfoIcon'
import styles from '../../threePsStyles.module.css'
import { ThreePsCategorizedCodes } from '../../../../../../../../../Models/applicationModels'
import { pluralize } from '../../threePsTable.utils'

export const TotalCodesIndicator = ({ tableData }: { tableData: { [key: string] : ThreePsCategorizedCodes[] } }) => {
    const getTableDataLength = () => {
        return Object.keys(tableData).reduce((acc, key) => acc + tableData[key].length, 0);
    }

    return (
        <p className={styles.noteHeaderTag}>
            <InfoIcon />
            {pluralize(getTableDataLength(), 'Total Code')}
        </p>
    )
}
